var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "px-3 mt-4" },
        [
          _c("mvmSearch", {
            attrs: { client: false },
            on: { onSearch: _vm.onSearch },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.mvms,
            "row-class-name": _vm.statusClass,
            height: "85vh",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "AssetNo", label: "機台編號", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "機台說明" },
          }),
          _c("el-table-column", {
            attrs: { prop: "client.name", label: "客戶" },
          }),
          _c("el-table-column", {
            attrs: { prop: "locate.name", label: "放置地址" },
          }),
          _c("el-table-column", {
            attrs: { prop: "model.name", label: "型號" },
          }),
          _c("el-table-column", {
            attrs: { prop: "user.name", label: "巡補員" },
          }),
          _c("el-table-column", {
            attrs: { label: "動作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deploy(scope.row)
                          },
                        },
                      },
                      [_vm._v("註冊")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            "before-close": _vm.handleClose,
            size: "90%",
            direction: "btt",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("h1", [_vm._v("請以QRCODE 掃描器掃描")]),
              _c("qrcode-vue", {
                attrs: {
                  value: _vm.mvm,
                  level: "H",
                  size: "300",
                  margin: "30",
                },
              }),
              _c("h3", [_vm._v("uid: " + _vm._s(_vm.uid))]),
              _c("h3", [_vm._v("機型: " + _vm._s(_vm.model.name))]),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [_vm._v("關閉")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }